import { render, staticRenderFns } from "./EmployeeCount.vue?vue&type=template&id=bdfb4e76&"
import script from "./EmployeeCount.vue?vue&type=script&lang=ts&"
export * from "./EmployeeCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports